import { isEveryNameOfKeyUnique } from 'services/utils'
import { KTestFunction, KTestConfig } from 'services/yup'

// !Tets Fns
const validateUniqueName: KTestFunction<{ name?: string }[]> = (objects) =>
  isEveryNameOfKeyUnique(
    objects?.filter((e) => !!e.name),
    'name'
  )

const validateUniqueId: KTestFunction<{ id?: number }[]> = (objects) =>
  isEveryNameOfKeyUnique(objects, 'id')

// !CFGs
export const isNameUniqueCFG: KTestConfig<{ name?: string }[]> = {
  test: validateUniqueName,
  message: 'form.validations.uniqueName',
}

export const isIdUniqueCFG: KTestConfig<{ id?: number }[]> = {
  test: validateUniqueId,
  message: 'form.validations.uniqueId',
}
